module.exports = __webpack_public_path__ + "assets/img/gif-1.fd91506d.gif";